module.exports = __webpack_public_path__ + "img/InvitationUser.5e7e66c8.jpg";